import { getEnv } from '../../../helpers/EnvHelper';
import React, { useContext, useEffect, useMemo, useState } from "react";
import TopToolbar from "./Toolbar/TopToolbar";
import DeepTek from "../../../assets/DeepTek.png";
import OutlineButton from "./Tools/ToolComponents/OutlineButton";
import studyviewerContext from "../../../context/studyviewer/StudyviewerContext";
import HeatMapButton from "./Tools/ToolComponents/HeatMapButton";
import ShowOriginal from "./Tools/ToolComponents/ShowOriginal";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import { useId } from "@fluentui/react-hooks";
import {
  ADVANCE_VIEWER_MODALITIES,
  ADVANCE_VIEWER_URL,
  BASIC_VIEWER_URL,
  COMPARE_TOOL_OBJECT,
  MPR_TOOL_OBJECT,
  REACT_ADVANCE_VIEWER_URL,
  REPORTDONESTATUS,
  SHOW_NOT_ORIGNAL_MODALITY_LIST,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  USERTYPES,
  ECG,
  showPathologyForModalities,
} from "../../../constants/Constants";
import { DefaultButton, Icon, PrimaryButton } from "@fluentui/react";
import CustomSpinner from "../../../components/CustomSpinner";
import { useTranslation } from "react-i18next";
import {
  downloadStudyZip,
  _base64ToArrayBuffer,
} from "../../../service/StudyViewerService";
import ThumbnailContext from "../../../context/studyviewer/ThumbnailContext";
import ViewportContext from "../../../context/studyviewer/ViewportContext";
import ReportIcon from "../../../components/SVGComponents/ReportIcon";
import AddPathologyIcon from "../../../components/SVGComponents/AddPathologyIcon";
import AnnotationBox from "../../Annotations/components/AnnotationBox/AnnotationBox";
import "../styles/styles.css";
import ChevronDownIcon from "../../../components/SVGComponents/ChevronDownIcon";
import ChatIcon from "../../../components/SVGComponents/ChatIcon";
import AttachmentIcon from "../../../components/SVGComponents/AttachmentIcon";
import AttachmentBox from "./AttachmentBox/AttachmentBox";
import ClinicalNotesIcon from "../../../components/SVGComponents/ClinicalNotesIcon";
import LockStudyTopBarIcon from "../../../components/SVGComponents/LockStudyTopBarIcon";
import studyReportContext from "../../../context/studyreport/StudyReportContext";
import DownloadButton from "./Tools/ToolComponents/DownloadButton";
import Augmento from "../../../components/SVGComponents/Logo/Augmento";
import DeeptekLogo from "../../../components/SVGComponents/Logo/DeeptekLogo";
import ShareStudyLink from "../../StudyList/components/Actions/ShareStudyLink";
import ShareIcon from "../../../components/SVGComponents/ShareIcon";
import ShareStudyContext from "../../../context/sharestudy/ShareStudyContext";
import { isMobile } from "react-device-detect";
import Back from "../../../components/SVGComponents/Tools/Back";
import themeContext from "../../../context/theme/ThemeContext";
import Tool from "./Tools/ToolComponents/Tool";
import userContext from "../../../context/users/UserContext";
import MPRToolComponent from "./Tools/ToolComponents/MPRToolComponent";
import BasicViewerSwitch from "../../../components/SVGComponents/BasicViewerSwitch";
import AdvanceViewerSwitch from "../../../components/SVGComponents/Tools/AdvanceViewerSwitch";
import AdvKeyImagesModal from "./AdvKeyImagesModal/AdvKeyImagesModal";
import AiDraftButton from "./AiDraft/AiDraftButton";
import useAiDraftToolbar from "./AiDraft/useAiDraftToolbar";
import KeyImage from "../../../components/SVGComponents/Tools/KeyImage";
import Impression from "../../../components/SVGComponents/Tools/Impression";
import Impressions from "./Overlays/Impressions";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import LockStudy from "./LockStudy/LockStudy";
import { KeyboardClassicIcon } from "@fluentui/react-icons-mdl2";
import TypistAccessCode from "../../StudyList/components/Typist/TypistAccessCode";
import MicToolComponent from "./Tools/ToolComponents/MicToolComponent";
import MobileViewerContext from "../../../context/studyviewer/MobileViewerContext";
import RebrandingLogo from "../../../components/SVGComponents/Logo/RebrandingLogo";
import { isLLMAgentPresent } from "../../../service/MaskImageService";
//added for quality flag
import useImageQuality from '../../../hooks/useImageQuality';
import QualityIcon from '../../../components/QualityIcon/QualityIcon';
import Attention from '../../../components/SVGComponents/Attention';



const AdvTopBar = (props) => {
  const {
    slideReportOpen,
    setSlideReportOpen,
    showHistory,
    setShowHistory,
  } = useContext(MobileViewerContext);
  const {
    studyData,
    messageCount,
    patientStudyData,
    studyModality,
    studyHistoryData,
    studyClinicalNotesData,
    assignmentData,
    firmViewerId,
    setSwitchingToBasic,
    studyParentAssignmentData,
    showAttachment, setShowAttachment,
    showClinicalNotes, setShowClinicalNotes,
    isTypistWorkflowEnabled,
    typistShowHistory,
    showChats,
    isPriorsStudy,
    reportMenu,
    showAccountWarning,
    setShowAccountWarning,
    accountWarningText,
    showAiResult,
    showSavedReport,
    studyResponseData,
    impressions,
    weasisViewerUser,
    infinitViewerUser
  } = useContext(studyviewerContext);

  const { theme,themeName } = useContext(themeContext);
  const {
    disableAddPathology,
    setDisableAddPathology,
    isMPRActive,
    showImpressions,
    setShowImpressions,
  } = useContext(ViewportContext);

  // The map is filled once the prior reports land (fetchPriorStudyReportsOnly). Until then
  // the panel would open empty, so the button waits. It does not require a *reported*
  // impression: the panel shows "not reported yet" rows too, same as the basic viewer.
  const hasImpressionsLoaded = useMemo(
    () => Object.keys(impressions || {}).length > 0,
    [impressions]
  );
  const {
    showLockWarning,
    lockStudy,
    showLockButton,
    alreadyLocked,
    setShowReturnStudyModal,
    reportDoneStatusState,
    showCommunicationModal,
    studyParentId,
    setShowCommunicationModal,
    lockStudySupervisor,
    studyDescription
  } = useContext(studyReportContext);


  // Which study the radiologist is working in, so the impressions panel can highlight it.
  const { activeStudyId } = useContext(ThumbnailContext);
  // const { activeModality } = useContext(ThumbnailContext);

  const { roles, authenticated, loadByUsername, username, userId, privilegedFirmDoctor, enableLlmReport,qcReviewer} =
    useContext(userContext);

  // Mic is never shown to firm admins.
  const isFirmAdmin = roles?.[0] === USERTYPES.FIRMADMIN;


  const { showShareStudyLinkModal, setShowShareStudyLinkModal } =
    useContext(ShareStudyContext);
  const [showManageAdvKeyImagesModal, setShowManageAdvKeyImagesModal] =
    useState(false);
  const [changeLockIcon, setChangeLockIcon] = useState(false);
  const [showTypistModal, setShowTypistModal] = useState(false);

  // AI Draft Report button (same as the basic viewer top bar)
  const { aiDraft, generateAiDraft, openAiDraftPanel, aiDraftPanel } = useAiDraftToolbar({
    studyId: studyParentId,
    keyImagesModalOpen: showManageAdvKeyImagesModal,
  });
  const [t] = useTranslation();

  //added for quality flag
  const { studyErrors } = useImageQuality(studyResponseData);


  const toolBarFlex = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  };

  const handleKeyImageClick = () => {
    setShowManageAdvKeyImagesModal(true);
  };

  const getStudyHistoryData = () => {
    return studyHistoryData;
  };

  const getStudyClinicalData = () => {
    return studyClinicalNotesData;
  };

  if (isMobile) {
    return (
      <>
        <div
          className="topbar-container w100"
          style={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="topbar-buttons">
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                padding: "0px 5px",
              }}
              onClick={() => window.close()}
            >
              <Back />
            </div>
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                paddingLeft: "6px",
              }}
            >
              {/* <Augmento /> */}
              <RebrandingLogo fallback={<DeeptekLogo darkTheme={true} />} />
            </div>
          </div>
          <div
            className="topbar-buttons cursor-pointer"
            style={{
              paddingRight: "6px",
            }}
          >
            {/* <TopToolbar
              openSeries={props.openSeries}
              seriesMenu={props.seriesMenu}
            /> */}
            <LockStudy
                changeLockIcon={changeLockIcon}
                setChangeLockIcon={setChangeLockIcon}
              />
            {/* Voice (dictation) — same button/condition as the mobile basic
                viewer top bar; the LLM chat mic replaces it when the agent is on. */}
            {!isFirmAdmin && !(enableLlmReport && isLLMAgentPresent(studyModality, studyDescription)) && (
              <div
                className="topbar-buttons cursor-pointer"
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingRight: "5px",
                  paddingTop: "3px",
                }}
              >
                <MicToolComponent />
                <span
                  style={{
                    fontSize: "8px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    color: "var(--mobile-color-txt)",
                    marginTop: "5px",
                  }}
                >
                  Voice
                </span>
              </div>
            )}
            {/* Account warning — mirrors the mobile basic viewer "Alert" button.
                AccountWarningModal is already mounted by AdvanceViewer. */}
            {(roles[0] == USERTYPES.RADIOLOGIST ||
              roles[0] === USERTYPES.SUPERVISOR ||
              roles[0] == USERTYPES.FIRMADMIN) &&
              accountWarningText &&
              accountWarningText.trim() !== "" && (
                <div
                  className="topbar-buttons cursor-pointer"
                  style={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingRight: "5px",
                    paddingTop: "3px",
                  }}
                  onClick={() => setShowAccountWarning(true)}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "20px",
                      height: "20px",
                      color: "#ff8c00",
                    }}
                  >
                    <Attention />
                  </span>
                  <span
                    style={{
                      fontSize: "8px",
                      lineHeight: "100%",
                      fontWeight: "400",
                      color: "var(--mobile-color-txt)",
                      marginTop: "5px",
                    }}
                  >
                    Alert
                  </span>
                </div>
              )}
            {roles[0] !== USERTYPES.FIRMDOCTOR && !props.isAdvFullscreen &&
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5px",
                paddingTop: "3px"
              }}
              onClick={() => {
                // Toggle logic: open report, close others
                setSlideReportOpen((prev) => !prev);
                setShowAttachment(false);
                setShowClinicalNotes(false);
                setShowCommunicationModal(false);
                setShowHistory(false);
              }}
            >
              <ReportIcon active={slideReportOpen} color={theme.palette.inactiveTool} />
              <span
                style={{
                  fontSize: "8px",
                  lineHeight: "100%",
                  fontWeight: "400",
                  color: "var(--mobile-color-txt)",
                  margin: "0px 4px",
                }}
              >
                Report
              </span>
            </div>
            }
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5px",
                paddingTop: "3px"
              }}
              onClick={() => setShowCommunicationModal(true)}
            >
              <ChatIcon 
                color={theme.palette.inactiveTool}
                active={showCommunicationModal} />
              {messageCount > 0 && <span className="message-count-tag"></span>}
              {isMobile && (
                <span
                  style={{
                    fontSize: "8px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    // color: "#FFFFFF",
                    color: "var(--mobile-color-txt)",
                    marginTop: "5px",
                  }}
                >
                  Chat
                </span>
              )}
            </div>
            {/* History & attachments — opens the same bottom sheet the mobile
                basic viewer uses (mounted by AdvanceViewer for mobile). */}
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5px",
                paddingTop: "3px",
              }}
              onClick={() => {
                if (!showHistory) {
                  setSlideReportOpen(false);
                  setShowCommunicationModal(false);
                }
                setShowHistory((prev) => !prev);
              }}
            >
              <span className="topbar-toolbar-right-icons">
                <AttachmentIcon
                  color={theme.palette.inactiveTool}
                  active={showHistory}
                />
                {(studyHistoryData?.length > 0 ||
                  studyClinicalNotesData?.length > 0) &&
                  !showHistory && <span className="default-show-dot"></span>}
              </span>
              <span
                style={{
                  fontSize: "8px",
                  lineHeight: "100%",
                  fontWeight: "400",
                  color: "var(--mobile-color-txt)",
                  marginTop: "6px",
                }}
              >
                History
              </span>
            </div>
            {/* Manage Key Images — same modal as the desktop advance viewer. */}
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5px",
                paddingTop: "3px",
              }}
              onClick={handleKeyImageClick}
            >
              <KeyImage color={theme.palette.inactiveTool} />
              <span
                style={{
                  fontSize: "8px",
                  lineHeight: "100%",
                  fontWeight: "400",
                  color: "var(--mobile-color-txt)",
                  marginTop: "5px",
                }}
              >
                Key Images
              </span>
            </div>
            {showManageAdvKeyImagesModal && (
              <AdvKeyImagesModal
                showManageAdvKeyImagesModal={showManageAdvKeyImagesModal}
                setShowManageAdvKeyImagesModal={setShowManageAdvKeyImagesModal}
                studyId={studyParentId}
              />
            )}
            {!(studyModality.toUpperCase() === ECG.toUpperCase()) && (
              <div
                className="topbar-buttons cursor-pointer"
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => {
                  if (window.location.href.includes("nonXrayAdvanceViewer")) {
                    window.open(
                      "/new/study/load/" + studyParentId + "?firmId=" + firmViewerId,
                      "_self"
                    );
                  } else {
                    window.open(
                      REACT_ADVANCE_VIEWER_URL +
                        studyParentId +
                        "?firmId=" +
                        firmViewerId,
                      "_self"
                    );
                  }
                }}
              >
                <AdvanceViewerSwitch color={theme.palette.inactiveTool} />
                {isMobile && (
                  <span
                    style={{
                      fontSize: "8px",
                      lineHeight: "100%",
                      fontWeight: "400",
                      // color: "#FFFFFF",
                      color: "var(--mobile-color-txt)",
                      marginTop: "3px",
                    }}
                  >
                    Basic Viewer
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="topbar-container w100">
          <div className="topbar-augmento-logo ">
            {/* <Augmento /> */}
            <RebrandingLogo fallback={<DeeptekLogo darkTheme={true} />} />
          </div>
          <div className="topbar-toolbar-container">
            <div className="topbar-toolbar-left-container">
              {/* <TopToolbar
                openSeries={props.openSeries}
                seriesMenu={props.seriesMenu}
              /> */}
            </div>
            <div className="topbar-toolbar-middle-container">
              {/* {props.priors && <Tool tool={COMPARE_TOOL_OBJECT} />}
              {!MPR_TOOL_OBJECT.NotFor.includes(activeModality) && (
                // <Tool tool={MPR_TOOL_OBJECT} />
                <MPRToolComponent />
              )} */}
              <div id="timerDisplayOnReportingPanel" className = "expiration-timer-container" style={{display:"none"}}>
                <span id="reportTimerText" className = "expiration-timer-text" ></span>
              </div>
            </div>

            <div className="topbar-toolbar-right-container h100">
              {
                <>
                  {/* Full Screen button hide in Advance Viewer
                  {props.onToggleFullscreen && (
                    <span
                      style={{
                        display: "flex",
                        margin: "0px 5px",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      onClick={props.onToggleFullscreen}
                    >
                      <div className="highlight-tool">
                        <CustomToolTipHost
                          content={props.isAdvFullscreen ? "Exit Full Screen" : "Full Screen"}
                          id="adv-fullscreen"
                        >
                          <span className="topbar-toolbar-right-icons">
                            <Icon
                              iconName={props.isAdvFullscreen ? "BackToWindow" : "FullScreen"}
                              style={{ color: theme.palette?.inactiveTool || "#fff", fontSize: "20px" }}
                            />
                          </span>
                        </CustomToolTipHost>
                      </div>
                    </span>
                  )} */}
                  {/* {getEnv("REACT_APP_HYBRID_MODE") == "true" && <span
                    style={{
                      display: "flex",
                      margin: "0px 5px",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={() => {
                      setSwitchingToBasic((prev)=> !prev);
                      window.open(
                        BASIC_VIEWER_URL + studyParentId + "?firmId=" + firmId,
                        "_self"
                      );
                    }}
                  >
                    <div className="highlight-tool">
                      <CustomToolTipHost
                        content={"Switch to Basic Viewer"}
                        id="basic-viewer"
                      >
                        <span className="topbar-toolbar-right-icons">
                          <BasicViewerSwitch />
                        </span>
                      </CustomToolTipHost>
                    </div>
                  </span>} */}

                  {/* Opens the impressions panel over the viewer -- the same overlay the
                      basic viewer uses, rendered in our own chrome rather than inside the
                      iframe. MedDream can only draw impressions as extra lines of its grey
                      corner metadata, with no styling and no way to hide them separately
                      from the DICOM labels, so the panel is ours. */}
                  {!weasisViewerUser && !infinitViewerUser && hasImpressionsLoaded && (
                    <span
                      style={{
                        display: "flex",
                        margin: "0px 5px",
                        position: "relative",
                      }}
                    >
                      {/* The toggle is on the icon, not the wrapper: the panel below is a
                          child of that wrapper (so it can be positioned against it), and a
                          handler up there would treat every click inside the panel --
                          copying, selecting text -- as a request to close it. */}
                      <div
                        className="highlight-tool cursor-pointer"
                        onClick={() => setShowImpressions((prev) => !prev)}
                      >
                        <CustomToolTipHost
                          content={
                            showImpressions ? "Hide Impressions" : "Show Impressions"
                          }
                          id="adv-impressions"
                        >
                          <span className="topbar-toolbar-right-icons">
                            <Impression
                              size={20}
                              color={
                                showImpressions
                                  ? theme.palette.activeTool
                                  : theme.palette.inactiveTool
                              }
                            />
                          </span>
                        </CustomToolTipHost>
                      </div>
                      {/* Hangs off this button rather than the top-left of the image area,
                          which in the Advance Viewer is MedDream own study panel. */}
                      <Impressions
                        highlightStudyId={activeStudyId}
                        anchored
                        showStudyDetails
                      />
                    </span>
                  )}

                  {!(studyModality.toUpperCase() === ECG.toUpperCase()) && (
                    <span
                      style={{
                        display: "flex",
                        margin: "0px 5px",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      onClick={() => {
                        if (
                          window.location.href.includes("nonXrayAdvanceViewer")
                        ) {
                          if(isPriorsStudy){
                            window.open(
                              "/new/study/priors/load/" +
                                studyParentId +
                                "?firmId=" +
                                firmViewerId,
                              "_self"
                            );
                          }else{
                            window.open(
                              "/new/study/load/" +
                                studyParentId +
                                "?firmId=" +
                                firmViewerId,
                              "_self"
                            );
                          }
                        } else {
                          window.open(
                            REACT_ADVANCE_VIEWER_URL +
                              studyParentId +
                              "?firmId=" +
                              firmViewerId,
                            "_self"
                          );
                        }
                      }}
                    >
                      <div className="highlight-tool">
                        <CustomToolTipHost
                          content={
                            window.location.href.includes(
                              "nonXrayAdvanceViewer"
                            )
                              ? "Switch to Basic Viewer"
                              : "Switch to Advance Viewer"
                          }
                          id="basic-viewer"
                        >
                          <span className="topbar-toolbar-right-icons">
                            <AdvanceViewerSwitch  color={theme.palette.inactiveTool}  />
                          </span>
                        </CustomToolTipHost>
                      </div>
                    </span>
                  )}
                </>
              }
                {(roles[0] == USERTYPES.RADIOLOGIST && (reportDoneStatusState == REPORTDONESTATUS.SAVED ||reportDoneStatusState == REPORTDONESTATUS.UNREPORTED ) &&  (isTypistWorkflowEnabled==1 || isTypistWorkflowEnabled==2)) &&
                <div
                  className="topbar-toolbar-share-study-modal-container cursor-pointer"
                  onClick={() => setShowTypistModal(true)}
                >
                  <CustomToolTipHost
                    id={"Assign Typist"}
                    content={ t("heading.typist")}
                  >
                    <div className="highlight-tool">
                      <KeyboardClassicIcon color={theme.palette.inactiveTool} />
                    </div>
                  </CustomToolTipHost>
                </div>
              }
              { !isFirmAdmin && !enableLlmReport &&
                <div className="highlight-tool cursor-pointer">
                  <MicToolComponent />
                </div>
              }
              <LockStudy
                changeLockIcon={changeLockIcon}
                setChangeLockIcon={setChangeLockIcon}
              />
              
              {/* here key images pop */}
              <CustomToolTipHost
                content={t("key-image.manage-key-image")}
                id="key-images"
              >
                <div className="highlight-tool cursor-pointer" onClick={handleKeyImageClick}>
                  <KeyImage color={theme.palette.activeTool} />
                </div>
              </CustomToolTipHost>
              <AiDraftButton
                aiDraft={aiDraft}
                onGenerate={generateAiDraft}
                onOpen={openAiDraftPanel}
                color={theme.palette.activeTool}
              />
              {aiDraftPanel}
              {showManageAdvKeyImagesModal && (
                <AdvKeyImagesModal
                  showManageAdvKeyImagesModal={showManageAdvKeyImagesModal}
                  setShowManageAdvKeyImagesModal={
                    setShowManageAdvKeyImagesModal
                  }
                  studyId={studyParentId}
                />
              )}
              {((roles[0] == USERTYPES.TYPIST && typistShowHistory) || roles[0] != USERTYPES.TYPIST)&&<>
              <span
                className="topbar-toolbar-history"
                style={{
                  cursor:
                    studyHistoryData.length > 0 ? "pointer" : "not-allowed",
                }}
                onClick={() => {
                  if (studyHistoryData.length > 0) setShowAttachment(true);
                }}
              >
                <span
                  style={{
                    display: "flex",
                    marginLeft: "5px",
                    merginRight: "5px",
                    cursor:
                      studyHistoryData.length > 0 ? "pointer" : "not-allowed",
                    position: "relative",
                  }}
                  onClick={() => {
                    if (studyHistoryData.length > 0) setShowAttachment(true);
                  }}
                >
                  <div className="highlight-tool">
                    <CustomToolTipHost
                      content={
                        studyHistoryData.length > 0
                          ? t("heading.attachment")
                          : t("search-message.no-attachment")
                      }
                      id="Attachment"
                    >
                      <span className="topbar-toolbar-right-icons">
                        <AttachmentIcon color={theme.palette.inactiveTool} active={showAttachment} />
                        {studyHistoryData.length > 0 && !showAttachment && (
                          <span className="default-show-dot"></span>
                        )}
                      </span>
                    </CustomToolTipHost>
                  </div>
                  <div>
                    <AttachmentBox
                      boxName="history"
                      show={showAttachment}
                      onClickOutside={() => {
                        setShowAttachment(false);
                      }}
                      setShowAttachment={setShowAttachment}
                      setShowPathologyOptions={props.setShowPathologyOptions}
                      setShowInfo1={showAttachment}
                      studyHistoryData={getStudyHistoryData()}
                    />
                  </div>
                </span>
              </span>

              <span
                className="topbar-toolbar-history"
                style={{
                  cursor:
                    studyClinicalNotesData.length > 0
                      ? "pointer"
                      : "not-allowed",
                  margin: "0px 5px",
                }}
                onClick={() => {
                  studyClinicalNotesData.length > 0 &&
                    setShowClinicalNotes(true);
                }}
              >
                <div className="highlight-tool">
                  <CustomToolTipHost
                    content={
                      studyClinicalNotesData.length > 0
                        ? t("heading.clinical-notes")
                        : t("search-message.no-clinical-notes")
                    }
                    id="ClinicalNotes"
                  >
                    <span className="topbar-toolbar-right-icons">
                      <ClinicalNotesIcon color={theme.palette.inactiveTool}  active={showClinicalNotes} />
                      {studyClinicalNotesData.length > 0 &&
                        !showClinicalNotes && (
                          <span className="default-show-dot"></span>
                        )}
                    </span>
                  </CustomToolTipHost>
                </div>
                <div>
                  <AttachmentBox
                    boxName="notes"
                    show={showClinicalNotes}
                    onClickOutside={() => {
                      setShowClinicalNotes(false);
                    }}
                    setShowClinicalNotes={setShowClinicalNotes}
                    setShowPathologyOptions={props.setShowPathologyOptions}
                    setShowInfo1={showClinicalNotes}
                    studyClinicalNotesData={getStudyClinicalData()}
                  />
                </div>
              </span>
              {/* Account Warning Button */}
                {(roles[0] == USERTYPES.RADIOLOGIST || roles[0] === USERTYPES.SUPERVISOR || roles[0] == USERTYPES.FIRMADMIN) && accountWarningText && accountWarningText.trim() !== "" && (
                  <span
                    style={{
                      display: "flex",
                      margin: "0px 5px",
                      cursor: "pointer",
                      position: "relative",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                    onClick={() => {
                      setShowAccountWarning(true);
                    }}
                  >
                    <div className="highlight-tool">
                      <CustomToolTipHost
                        content="Account Warning"
                        id="account-warning"
                      >
                        <span
                          className="topbar-toolbar-right-icons"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "12px", 
                            width: "20px", 
                            height: "20px", 
                            color: "#ff8c00", 
                          }}
                        >
                          <Attention/>
                        </span>
                      </CustomToolTipHost>
                    </div>
                  </span>
                )}


              </>}
              <div className="separator-topbar-items"></div>
              <div className="topbar-buttons">
                {((roles[0] == USERTYPES.TYPIST && showChats) || roles[0] != USERTYPES.TYPIST)&&<div
                  className="topbar-toolbar-communication cursor-pointer"
                  onClick={() => setShowCommunicationModal(true)}
                >
                  <div className="highlight-tool">
                  <span className="topbar-toolbar-right-icons">
                    <ChatIcon 
                      //color={true} 
                      color={theme.palette.inactiveTool}
                      active={showCommunicationModal} 
                      />
                    {messageCount > 0 && (
                      <span className="message-count-tag"></span>
                    )}
                  </span>
                  </div>
                </div>}
                {/* <div className="topbar-toolbar-communication-modal-container cursor-pointer">
                  <div className="highlight-tool">
                    <DownloadButton />
                  </div>
                </div> */}
                {showTypistModal &&
                  <TypistAccessCode  setShowTypistModal = {setShowTypistModal} studyId = {studyParentId} isTypistWorkflowEnabled={isTypistWorkflowEnabled}/>
                }
                {showShareStudyLinkModal && (
                  <ShareStudyLink
                    studyId={studyParentId}
                    firmId={assignmentData.firmId}
                    clientId={assignmentData.clientId}
                  />
                )}

                <div
                  className="topbar-toolbar-share-study-modal-container cursor-pointer"
                  onClick={() => setShowShareStudyLinkModal(true)}
                >
                  <div className="highlight-tool">
                    <ShareIcon color={theme.palette.inactiveTool} />
                  </div>
                </div>
              </div>
              {roles.length > 0 && ((!roles[0].includes(USERTYPES.FIRMDOCTOR) && !roles.includes(USERTYPES.FIRMTECHNICIAN)) || showSavedReport) && !props.isAdvFullscreen && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <CustomToolTipHost content="Report" id="View Report">
                    <button
                      onClick={props.openReport}
                      className="view-report-primay-button"
                      style={{
                        background: reportMenu
                          ? "rgb(0, 120, 212)"
                          : "transparent",
                        border: reportMenu
                          ? "1px solid transparent"
                          : "1px solid #C3C4CD",
                      }}
                    >
                      <span style={{ display: "flex" }}>
                        <ReportIcon active={reportMenu}  color={theme.palette.inactiveTool} />
                      </span>
                      <span className="view-report-button-text" style={{color:reportMenu || themeName !== "light"?"#FFF":"#000"}}>
                        {t("report-version.report")}
                      </span>
                    </button>
                  </CustomToolTipHost>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default AdvTopBar;
